module.exports = __webpack_public_path__ + "img/logo.02cbf123.png";